﻿import {makeApiCall} from "./client";
import type {MeasurementMoment} from "../types/measurement-moment.type";
import type {MeasurementMomentExpanded} from "../types/expanded-measurement-moment.type";
import type {SectionMeasurement} from "../types/measurements/section-measurement.type";

export async function fetchMeasurementMomentExpanded(id: string): Promise<MeasurementMomentExpanded> {
    const [
        moments,
        sectionMeasurements,
        flowMeasurements,
        congestionMeasurements,
        trafficMeasurements
    ] = await Promise.all([
        makeApiCall(`odata/MeasurementMoments/${id}`),
        makeApiCall(`odata/SectionMeasurements?$filter=MeasurementMomentId eq ${id}`),
        makeApiCall(`odata/FlowMeasurements?$filter=MeasurementMomentId eq ${id}`),
        makeApiCall(`odata/CongestionMeasurements?$filter=MeasurementMomentId eq ${id}`),
        makeApiCall(`odata/TrafficMeasurements?$filter=MeasurementMomentId eq ${id}`)
    ]);

    const moment = transformMomentsToDates<MeasurementMomentExpanded>(moments)[0];

    return {
        ...moment,
        sectionMeasurements,
        flowMeasurements,
        congestionMeasurements,
        trafficMeasurements
    };
}

export async function fetchProjectMeasurementMomentsAsc(projectId: string): Promise<MeasurementMoment[]> {
    const moments = await makeApiCall(
        `odata/MeasurementMoments?$filter=ProjectId eq ${projectId}&$orderby=Moment asc`
    );
    
    return transformMomentsToDates<MeasurementMoment>(moments);
}

export async function fetchSectionMeasurementMoments(projectId: string): Promise<SectionMeasurement[]> {
    // Adding a max to avoid the front end crashing when the server returns too many results
    // TO DO: Find a way to get these batched
    return await makeApiCall(
        `odata/SectionMeasurements?$top=1000000&$filter=ProjectId eq ${projectId}&$select=Moment,SectionId,Duration,TypicalDuration`
    );
}

function transformMomentsToDates<T extends MeasurementMoment>(moments: T[]){
    return moments.map((moment) => ({
        ...moment,
        moment: new Date(moment.moment),
    }));
}